<template>
  <div class="wrapper">
    <dash-header></dash-header>
    <sidebar></sidebar>

    <div class="content-wrapper p-3">
      <div class="content-header">

        <template v-if="!loading">
          <template v-if="isIbAccountWithCorrectValue">
            <template v-if="admission_status !== 'PENDING'">
              <dashboard-ib :ib="ibAccount" />
            </template>

            <template v-else>
              <dashboard-pending-ib :loading="loading" />
            </template>
          </template>

          <template v-else>
            <dashboard-not-ib :loading="loading" />
          </template>
        </template>

        <div class="d-flex align-items-center justify-content-center loading" v-if="loading">
          <h1>
            <span class="spinner-border spinner-border-sm text-danger"></span>
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import DashHeader from "../../layouts/Header.vue"
import Sidebar from "../../layouts/Sidebar.vue"
import DashboardIb from "./DashboardIb.vue"
import DashboardNotIb from "./DashboardNotIb.vue"
import DashboardPendingIb from "./DashboardPendingIb.vue"

export default {
  name: "Dashboard",

  components: {
    DashHeader,
    Sidebar,
    DashboardIb,
    DashboardNotIb,
    DashboardPendingIb
  },

  data : () => ({
    ibAccount : new Promise(function(){}),
    loading : false
  }),

  computed: {
    admission_status(){
      return this.ibAccount?.admission_status ?? false
    },
    isIbAccountLoaded(){
      return !(this.ibAccount instanceof Promise)
    },
    isIbAccountWithCorrectValue(){
      return this.isIbAccountLoaded && this.ibAccount
    }
  },

  async mounted(){
    window.scrollTo(0,0)
    this.loading = true
    
    try{
      let ib = await this.get_ib()

      if( typeof ib == 'undefined' ){
        throw new Error('not an IB')
      }

      this.ibAccount = ib ? { ...this.ibAccount, ...ib } : ib
    }catch( err ){
      this.ibAccount = undefined
      this.$router.push('introduction-broker/type')
    }finally{
      this.loading = false
    }
  },

  methods: {
    /**
     * Method untuk request IB
     */
    async get_ib(){
      let resp = await axios.get(`investor/${localStorage.user_id}/ib/`)

      if( resp?.data?.data ){
        if( Array.isArray(resp.data.data) ){
          return resp.data.data[0]
        }
      }
      
      return undefined
    }
  }
};
</script>